// ABOUTME: Defines action availability for parser operation rows in applicant upload.
// ABOUTME: Keeps parser failure states from navigating into screens without parsed CV data.
export type ParserItemRowData = {
    pk: string;
    skGS1pk: string;
    jsonCV?: unknown;
    cv?: {
        key?: string;
        originalFileName?: string;
    };
    status?: {
        value?: string;
    };
};

const REVIEWABLE_STATUS_VALUES = ["1", "requested", "error"];
const REFRESHABLE_OPERATION_STATUS_VALUES = ["partiallyProcessed", "requested"];

const isAllowedParserItemStatus = (rowData: ParserItemRowData) =>
    REVIEWABLE_STATUS_VALUES.includes(rowData.status?.value || "");

const hasParserResponse = (rowData: ParserItemRowData) =>
    Boolean(rowData.jsonCV);

const hasParserCv = (rowData: ParserItemRowData) => Boolean(rowData.cv?.key);

export const canReviewParserItem = (rowData: ParserItemRowData) =>
    hasParserResponse(rowData) &&
    hasParserCv(rowData) &&
    isAllowedParserItemStatus(rowData);

export const getParserItemActionState = (rowData: ParserItemRowData) => {
    const hidden = !isAllowedParserItemStatus(rowData) || !hasParserCv(rowData);

    return {
        hidden,
        disabled: hidden || !canReviewParserItem(rowData)
    };
};

export const shouldRefreshParserOperationItems = (status?: string) =>
    REFRESHABLE_OPERATION_STATUS_VALUES.includes(status || "");

export const shouldPollParserOperationItems = (
    status?: string,
    parserUploadReady = false
) =>
    !parserUploadReady && shouldRefreshParserOperationItems(status);

export const getParserItemReviewPath = (rowData: ParserItemRowData) =>
    `/applicant/newparsed/verificationData/${
        rowData.pk.split(":")[1]
    }/${rowData.skGS1pk.split(":")[1]}`;
